import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * PWD212 計劃託工單模組權限 hook
 *
 * 基於 pgCode = "pwd212f1"（SYS_Program 中的計劃託工單程式代碼）
 */
export function usePWD212Permissions() {
  return useModulePermission(Modules.PWD212);
}
